import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CuttingButt } from '../models/cutting/cutting-butt.model';
import { CuttingMatBaseGroup, TypeGroupMaterial } from '../models/cutting/cutting-material-group.model';
import { ApiLinks } from '../modules/cutting-panel-list/csl.api-links';
import {
  MaterialBaseButtResponse,
  MaterialBaseButtsService,
} from '../modules/material-base-butts/material-base-butts.service';

@Injectable()
export class CuttingButtFormService implements MaterialBaseButtsService {
  constructor(
    private http: HttpClient, //
    
  ) {}

  getMatchedButtsForClient(matInMatBaseId: number, panelThickness = 0): Promise<CuttingButt[]> {
    const httpParams: HttpParams = new HttpParams()
      .set('materialInMatBaseId', matInMatBaseId.toString())
      .set('panelThickness', panelThickness.toString());

    return new Promise((resolve, reject) => {
      this.http
        .get(ApiLinks.matchedButts, { params: httpParams })
        .subscribe((response: CuttingButt[]) => {
          resolve(response);
        }, reject);
    });
  }

  getButtsThickneses(): Promise<number[]> {
    return new Promise((resolve, reject) => {
      this.http.get(ApiLinks.buttsThickneses, {}).subscribe((response: number[]) => {
        resolve(response);
      }, reject);
    });
  }

  getButtsFromMatBase(
    groupId: number,
    pageSize: number,
    pageNum: number,
    filterText: string,
    filterByThickness = 0,
    panelThickness = 0
  ): Promise<MaterialBaseButtResponse> {
    if (pageNum < 0 || pageSize === 0) {
      return new Promise((resolve, reject) => {
        resolve({
          materialsDTO: [],
          materialsCount: 0,
        });
      });
    }

    const searchParams: HttpParams = new HttpParams()
      .set('groupId', groupId.toString())
      .set('pageSize', pageSize.toString())
      .set('pageNum', pageNum.toString())
      .set('filterText', filterText)
      .set('filterThickness', filterByThickness.toString())
      .set('panelThickness', panelThickness.toString());

    return new Promise((resolve, reject) => {
      this.http
        .get(ApiLinks.butt, { params: searchParams })
        .subscribe((response: MaterialBaseButtResponse) => {
          resolve(response);
        }, reject);
    });
  }

  getButtGroupsFromMatBase(): Promise<CuttingMatBaseGroup[]> {
    let params = new HttpParams();
    params = params.append('groupType', TypeGroupMaterial.Butt);

    return new Promise((resolve, reject) => {
      this.http
        .get<CuttingMatBaseGroup[]>(ApiLinks.materialGroup, { params })
        .subscribe((g: CuttingMatBaseGroup[]) => {
          resolve(g);
        }, reject);
    });
  }
}
